import { Filter } from '@app/types/filter.types';
import { createAction, props } from '@ngrx/store';

export const storeFilters = createAction('[Filter] addfilter', props<{ materialFilters: Filter[], customerFilters: Filter[] }>());
